import { FieldDataType } from '../enums/FieldDataType';
import { FieldValidationType } from '../enums/FieldValidationType';

export function mapFieldDataType(validationType: FieldValidationType) {
    switch (validationType) {
        case FieldValidationType.email:
        case FieldValidationType.other:
        case FieldValidationType.usMobilePhone:
            return FieldDataType.string;
        case FieldValidationType.years:
            return FieldDataType.integer;
        case FieldValidationType.dollars:
            return FieldDataType.float;
        case FieldValidationType.date:
            return FieldDataType.date;
        case FieldValidationType.none:
            return FieldDataType.none;
        case FieldValidationType.address:
            return FieldDataType.address;
        default:
            return FieldDataType.text;
    }
}

//export function createClientField({
//    validationType,
//    label,
//    isUnique,
//    isFilterable,
//    isPrimary
//}: {
//    validationType: FieldValidationType;
//    label: string;
//    isUnique?: boolean;
//    isFilterable?: boolean;
//    isPrimary?: boolean;
//}): CreateClientFieldRequest {
//    return {
//        fieldType: mapFieldDataType(validationType),
//        validationType: validationType,
//        label: label,
//        isUnique: isUnique || false,
//        isFilterable: isFilterable || false,
//        isPrimary: isPrimary || false
//    }
//}
